<bzg-modal-header class="bmc-modal-header">
  <span class="bzg-modal__header__title">{{ 'DEPLOYMENT.DEPENDENCIES' | translate }}</span>
  <bzg-button-icon icon="icn-close" (click)="close()"></bzg-button-icon>
</bzg-modal-header>
<bzg-modal-content>
  <div class="bmc-package-dependencies" *ngIf="(isLoading$ | async) === false;else loading_package_dependencies">
    <div class="bmc-package-dependencies__header bz-space--stack-m">
      <bzg-select name="selectAuthenticator" class="bmc-package-dependencies__header__select"
        [placeholder]="('AUTHENTICATION.SELECT_AUTHENTICATOR_PLACEHOLDER' | translate) + '...'"
        (valueChange)="pathChanged($event)" [value]="selectedPath">
        <bzg-option *ngFor="let path of paths" [value]="path">
          {{path}}
        </bzg-option>
      </bzg-select>
      <!--      < {{'package_dependencies.back' | translate}}</a> <div class="form-group path">-->
      <!--        <select class="form-control" id="paths" required [(ngModel)]="pathSelected" name="pathSelected"-->
      <!--          (ngModelChange)="pathChanged($event)">-->
      <!--          <option *ngFor="" [value]="path">{{path}}</option>-->
      <!--        </select>-->
      <!--  </div>-->
      <div class="title">
        <div class="title-icon">
          <app-svg-icons icon="icon-{{icon}}" class="bz-icon bz-icon-32-title"></app-svg-icons>
        </div>
        <span class="title-text">{{objectName}}</span>
      </div>
      <div class="">
        <bzg-button-secondary (click)="orientation = 'LR'" class="bz-space--inline-s bz-space--stack-s" size="s"
          icon="icon-align-left">
          <span class="icon-text">{{'DEPLOYMENT.DEPENDENCIES_LR' | translate}}</span>
        </bzg-button-secondary>
        <bzg-button-secondary (click)="orientation = 'TB'" class="bz-space--inline-s bz-space--stack-s" size="s"
          icon="icon-align-top">
          <span class="icon-text">{{'DEPLOYMENT.DEPENDENCIES_TB' | translate}}</span>
        </bzg-button-secondary>
        <bzg-button-secondary (click)="zoomToFit()" class="bz-space--inline-s bz-space--stack-s" size="s"
          icon="icon-fit-zoom">
          <span class="icon-text">{{'DEPLOYMENT.DEPENDENCIES_FIT_ZOOM' | translate}}</span>
        </bzg-button-secondary>
      </div>
    </div>
    <div class="bmc-package-dependencies__content" *ngIf="!noresults && hierarchialGraph?.nodes != null">
      <ngx-graph #graph class="chart-container" layout="dagre" [view]="view" [enableZoom]="enableZoom"
      [autoZoom]="autoZoom" [layoutSettings]="{ orientation: orientation }" [panOnZoom]="panOnZoom"
      [panOffsetX]="panOffsetX" [panOffsetY]="panOffsetY" [zoomLevel]="zoomLevel" [autoCenter]="autoCenter"
      [legend]="showLegend" [links]="hierarchialGraph.links" (legendLabelClick)="onLegendLabelClick($event)"
      [nodes]="hierarchialGraph.nodes" [scheme]="colorScheme" [curve]="curve" [draggingEnabled]="false"
      [panningEnabled]="true" [update$]="update$" [zoomToFit$]="zoomToFit$" [center$]="center$"
      (select)="select($event)">
  <ng-template #defsTemplate>
    <svg:marker id="arrow" viewBox="0 -5 10 10" refX="8" refY="0" markerWidth="4" markerHeight="4" orient="auto">
            <svg:path d="M0,-5L10,0L0,5" class="arrow-head" />
          </svg:marker>
  </ng-template>

  <ng-template #nodeTemplate let-node>
    <svg:g class="node" ngx-tooltip [tooltipPlacement]="'top'" [tooltipType]="'tooltip'"
            [tooltipTitle]="node.label">
            <svg:rect [attr.width]="node.dimension.width" [attr.height]="node.dimension.height"
              [attr.fill]="node.data.color" />
            <svg:text alignment-baseline="central" [attr.x]="10" [attr.y]="node.dimension.height / 2">
              {{ 'DEPLOYMENT.' + node.label | translate }}
            </svg:text>
          </svg:g>
  </ng-template>

  <ng-template #linkTemplate let-link>
    <svg:g class="edge">
            <svg:path class="line" stroke-width="2" marker-end="url(#arrow)"></svg:path>
            <svg:text class="edge-label" text-anchor="middle">
              <textPath class="text-path" [attr.href]="'#' + link.id" [style.dominant-baseline]="link.dominantBaseline"
                startOffset="50%">
                {{ 'DEPLOYMENT.' + link.label | translate }}
              </textPath>
            </svg:text>
          </svg:g>
  </ng-template>
</ngx-graph>

    </div>


    <div class="bmc-package-dependencies__content" *ngIf="noresults">
      <div class="no-result">
        <i class="bz-icon bz-icon-16 bz-default-icon"></i>
      </div>
    </div>
  </div>
  <ng-template #loading_package_dependencies>
    <div class="bmc-package-dependencies__loading">
      <bzg-loading [size]="'s'">
        {{'GLOBAL.LOADING_DATA' | translate}}
      </bzg-loading>
    </div>
  </ng-template>
</bzg-modal-content>
<bzg-modal-footer class="bmc-delete-alert__footer">
  <bzg-button-secondary (click)="close()">{{ 'GLOBAL.CLOSE' | translate }}
  </bzg-button-secondary>
</bzg-modal-footer>
